<template>
  <main id="maintenance-wrapper">
    <div class="container">
      <div class="row" v-if="maintenance">
        <div class="col-12 text-center">
          <h1 class="text-uppercase">Estamos em manutenção</h1>
          <p class="text-muted mb-5">Volte em breve...</p>
          <a href="https://www.zmaisconstrutora.com.br" id="btn-return">Voltar para o site</a>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

import Vue from 'vue'
import axios from 'axios'

export default {

  name: 'Maintenance',

  data() {

    return {

      maintenance: false

    }

  },

  mounted() {

    axios
    .request({ // Request token

      url: Vue.pathToken,
      method: "post",
      baseURL: Vue.baseURL,
      auth: {
        username: Vue.clientId,
        password: Vue.clientSecret
      },
      data: {
        "grant_type": "client_credentials"
      }

    }).then(response => {

      if (response.status == 200) {

        const headers = this.generateHeaders(response.data.access_token)

        axios
        .request({

          method: 'post',
          url: Vue.pathEnterprises,
          baseURL: Vue.baseURL,
          headers: headers

        }).then(response => {

          if (response.status == 200) {

            this.$router.push('/')

          } else {

          this.maintenance = true

          }

        })
        .catch(() => {

          this.maintenance = true

        })

      } else {

        this.maintenance = true

      }

    }).catch(() => {

      this.maintenance = true

    })

  },

  methods: {

    generateHeaders(token) {

      const headers = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/x-www-form-urlencoded'
      }

      return headers

    },

  }

}
</script>

<style lang="less" scoped>

#maintenance-wrapper {
  padding: 100px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  #btn-return {
    background: #0d7658;
    color: #FFFFFF;
    padding: 16px 48px;
    font-size: 12.8px;
    text-transform: uppercase;
    letter-spacing: .4px;
    font-weight: 600;
    border-radius: 3px;
    text-decoration: none;
    transition: background .2s linear;
    &:hover {
      background: #231f20;
    }
    &:focus {
      background: #231f20;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Maintenance.vue